/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ListSocialDrawerVisibilityResponse,
} from '../models/index';
import {
    ListSocialDrawerVisibilityResponseFromJSON,
    ListSocialDrawerVisibilityResponseToJSON,
} from '../models/index';

/**
 * SocialDrawerApi - interface
 * 
 * @export
 * @interface SocialDrawerApiInterface
 */
export interface SocialDrawerApiInterface {
    /**
     * Get social drawer feature visibility settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SocialDrawerApiInterface
     */
    getSocialDrawerVisibilityRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListSocialDrawerVisibilityResponse>>;

    /**
     * Get social drawer feature visibility settings
     */
    getSocialDrawerVisibility(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListSocialDrawerVisibilityResponse>;

}

/**
 * 
 */
export class SocialDrawerApi extends runtime.BaseAPI implements SocialDrawerApiInterface {

    /**
     * Get social drawer feature visibility settings
     */
    async getSocialDrawerVisibilityRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListSocialDrawerVisibilityResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/social-drawer/visibility`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListSocialDrawerVisibilityResponseFromJSON(jsonValue));
    }

    /**
     * Get social drawer feature visibility settings
     */
    async getSocialDrawerVisibility(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListSocialDrawerVisibilityResponse> {
        const response = await this.getSocialDrawerVisibilityRaw(initOverrides);
        return await response.value();
    }

}
